




















import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { TaskInstance } from '../types/task'
import AuditInfoItem from './taskHandle/common/AuditInfoItem.vue'

@Component({
  components: { AuditInfoItem }
})
export default class ViewAuditHistory extends Vue {
  @Prop() public visible!: boolean
  @Prop() public data!: TaskInstance

  public showModal() {
    this.$emit('change', true)
  }
  public handleOk(e) {
    this.$emit('change', false)
  }
}
